import styles from "./BlockResume.module.css";


const BlockResume = ({props}) =>{

const elem = props.map((item)=>{
    return(
        <div className={styles.blockResume}>
            <h2 className={styles.titleBlock}>{item.type}</h2>
            <p className={styles.description}>{item.location}</p>
            <p className={styles.description}>{item.description}</p>
        </div>
    )
})
   return elem

}

export default BlockResume